import { readHalmParametersQueryString } from "../utils/halmParameters";
import {
  isQuizSummaryItemApplicable,
  QUIZ_SUMMARY_ITEMS,
  type QuizSummaryPageContext,
} from "./quizSummaryItems";
import "./QuizSummary.css";

const FILLOUT_QUIZ_URL = "https://quiz.halm.club/rasen-analyse3";

const formatSummaryText = (items: string[]) =>
  items.length > 0 ? items.join(", ") + " + weitere." : "+ weitere.";

const buildFilloutUrl = () => {
  const quizUrl = new URL(FILLOUT_QUIZ_URL);
  quizUrl.searchParams.set("quiz_id", String(Date.now()));
  return quizUrl.toString();
};

export function QuizSummary(pageContext: QuizSummaryPageContext) {
  const params = new URLSearchParams(readHalmParametersQueryString());

  if (!params.has("quiz_id")) {
    return null;
  }

  const visibleItems = QUIZ_SUMMARY_ITEMS.flatMap((item) => {
    const value = params.get(item.key);

    if (!value || !isQuizSummaryItemApplicable(item, pageContext)) {
      return [];
    }

    const label = item.getLabel(value, params);
    return label ? [label] : [];
  });
  const summaryText = formatSummaryText(visibleItems);

  return (
    <aside className="react-pdp__quiz-summary" aria-label="Rasenanalyse">
      <span
        className="material-symbols-rounded react-pdp__quiz-summary-icon"
        aria-hidden="true"
      >
        check_circle
      </span>
      <div className="react-pdp__quiz-summary-content">
        <p className="react-pdp__quiz-summary-heading">
          Deine Angaben werden berücksichtigt.
        </p>
        <p className="react-pdp__quiz-summary-text">
          {summaryText ? <span>{summaryText} </span> : null}
          <a className="react-pdp__quiz-summary-link" href={buildFilloutUrl()}>
            Angaben ändern
          </a>
        </p>
      </div>
    </aside>
  );
}
